<div
  #infoContainer
  *ngIf="record"
  class="record__wrapper"
  [ngClass]="textDirection"
  [@desktopAnimation]="desktopAnimation"
  [@mobileAnimation]="mobileAnimation"
  (@mobileAnimation.done)="handleAnimationEnd()"
  (@desktopAnimation.done)="handleAnimationEnd()"
>
  <button
    (click)="closeInfo()"
    mat-flat-button
    class="only-icon record__wrapper-close"
    [attr.aria-label]="'common.close' | translate">
    <span class="odilo-icon" aria-hidden="true">close</span>
  </button>

  <div class="record__left">
    <div class="record__left__img">
      <a [routerLink]="getRecordUrl(record)" (click)="saveActiveRecord()" tabindex="-1">
        <opac-record-cover
          [coverUrl]="record.coverImageUrl"
          [icon]="record.icon"></opac-record-cover>
      </a>
    </div>
  </div>

  <div class="record__right">
    <div class="record-title with-close-item">
      <h2 class="record__right__title" [ellipsis]="2">
        <div class="accessibility-focus-element" tabindex="0" #accessibilityAutofocus></div>
        <a #title [routerLink]="getRecordUrl(record)" (click)="saveActiveRecord()" [appRecordTitle]="record"></a>
      </h2>
      <button *ngIf="issueDate" class="record-issueDate">{{issueDate | parseDate}}</button>
    </div>

    <p *ngIf="record.author" class="record__right__subtitle">
      <a ellipsis routerLink="/results" [queryParams]="searchByAuthor(record.author)"
        >{{record.author}}</a
      >
    </p>

    <div class="record__right__interactions">
      <app-rating class="interactions__rating" [record]="record" [readOnly]="readOnly"></app-rating>

      <app-favorite-button
        class="interactions__button"
        *ngIf="authService.isAuthenticated()"
        [record]="record"></app-favorite-button>

      <app-share-button
        *ngIf="showSocialIcons"
        [include]="socialButtons"
        [url]="getSharingUrl(record.id)"
        [title]="record.title"
        [description]="shareText"></app-share-button>
    </div>

    <div class="record__right__buttons">
      <app-record-buttons
        from="INIT_SCREEN"
        [record]="record"
        [issueDate]="issueDate"
        [config]="buttonsConfig"
        [callback]="toggleShowGallery"></app-record-buttons>
    </div>

    <div class="record__right__description">
      <app-image-gallery
        *ngIf="showGallery"
        from="INIT_SCREEN"
        [images]="images"
        [recordId]="record.id"
        [placeholder]="false"></app-image-gallery>

      <div tabindex="0" class="fade-description-left" [innerHTML]="record.description"></div>

      <div class="record__right__electronic_location" *ngIf="record.electronicLocation">
        <div *ngFor="let item of record.electronicLocation">
          <a [href]="item.uri" target="_blank" rel="noopener">{{item.label}}</a>
          <span class="odilo-icon">external_link</span>
        </div>
      </div>

      <div class="record__right__topics">
        <button mat-flat-button *ngFor="let subject of record.subjects" tabindex="-1">
          <a [routerLink]="['/results']" [queryParams]="buildTopicFacetQuery(subject)">{{subject}}</a>
        </button>
      </div>

      <button mat-flat-button class="btn-icon-text description__more" tabindex="-1">
        <span class="text">
          <a (click)="saveActiveRecord()" [routerLink]="getRecordUrl(record)">{{'common.viewMore' | translate}}</a>
        </span>
        <span class="odilo-icon" aria-hidden="true">navigate_next</span>
      </button>
    </div>
  </div>
</div>
